export default {
  welcome: {
    greetings: `Привет! {br}
    Рады приветствовать тебя! {br}
    Мы уже начали заниматься подготовкой твоего выхода в компанию :) {br}
    Сейчас для нас очень важна информация из двух разделов анкеты: {contactDetails} и {organizationalMatters}. {br}
    Заполни их {dueDate}, пожалуйста. {br}
    Спасибо!`,
    by: 'до',
    on: '',
    contactDetails: 'личные данные',
    organizationalMatters: 'организационные вопросы',
  },
  finished: {
    title: `Регистрация завершена.{0}Добро пожаловать в\xa0компанию!`,
  },
  willNotSaved: 'Файл не будет сохранен',
  updating: {
    title: 'Технические работы',
    broken: 'Кто-то сломал наш сайт!',
    underMaintenance: 'На самом деле нет – ведутся технические работы.',
    tryLater: 'Попробуйте {0} позже.',
    refreshPage: 'обновить страницу',
  },
};
